// extracted by mini-css-extract-plugin
export var dateLabel = "_3h-0";
export var dateLabelError = "_3h-1";
export var fullWidth = "_3h-2";
export var smaller = "_3h-3";